export const LOCAL_STORAGE_KEYS = {
    AUTH_STATE: "LocalStorageKeys.AuthState",
    DISMISSED_WILL_REPLY: "LocalStorageKeys.dismissedWillReply-v2",
};

export const PRIVACY_FRAGMENT = "#privacy-policy";

export const UCAS_TOS =
    "https://www.ucas.com/about-us/policies/privacy-policies-and-declarations/ucas-privacy-policy";
